import React, { useState, useEffect } from 'react';
import './IntroOverlay.css';
import introVideoDesktop from '../../assets/Intro.mp4'; 
import introVideoMobile from '../../assets/Intro_mobile.mp4'; // Ensure this exists

const IntroOverlay = () => {
  const [isMobile, setIsMobile] = useState(false);

  // --- DETECT SCREEN SIZE ---
  useEffect(() => {
    const handleResize = () => {
      // Sets mobile view for tablets and phones (standard breakpoint 991px or 768px)
      setIsMobile(window.innerWidth <= 991); 
    };

    // Initial check
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="intro-container">
      <video 
        className="intro-video" 
        // Switches source based on screen size
        src={isMobile ? introVideoMobile : introVideoDesktop} 
        autoPlay 
        muted 
        playsInline 
        // Adding a key forces the video tag to re-render when the source changes
        key={isMobile ? "mobile" : "desktop"}
      />
    </div>
  );
};

export default IntroOverlay;